import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { type FleetSummary as Summary, SlotStatus } from '@/models/vault'
import { rollupLabel, statusStyle } from './slotStatus'
import { useVault } from './VaultContext'

/** The two statuses that are about a date passing, which is what the timeline is for. */
const DATED = [SlotStatus.EXPIRING_SOON, SlotStatus.EXPIRED]

/** Beside the welcome: what lapses when, with the counts that send a carrier into the timeline. */
export function TimelineCard({ summary }: { summary: Summary }) {
  const { href } = useVault()
  return (
    <Card className="gap-3 bg-[radial-gradient(ellipse_at_top_right,var(--color-brand-100),var(--color-surface)_70%)] py-4">
      <CardHeader>
        <CardTitle>Expirations</CardTitle>
      </CardHeader>
      <CardContent>
        <dl aria-label="Files by expiry" className="flex flex-wrap items-baseline gap-x-6 gap-y-1 text-sm">
          {DATED.map((status) => (
            // Term before description, as a definition list needs; reversed so the count still reads first.
            <div key={status} className="flex flex-row-reverse items-baseline gap-1.5">
              <dt className="text-muted-foreground">{rollupLabel(status)}</dt>
              <dd
                className={cn(
                  'text-base font-semibold',
                  summary.byStatus[status] > 0 ? statusStyle(status).text : 'text-muted-foreground'
                )}
              >
                {summary.byStatus[status]}
              </dd>
            </div>
          ))}
        </dl>
      </CardContent>
      <CardFooter>
        <Button asChild variant="ghost">
          <Link to={href('timeline')}>
            View expiration timeline
            <ChevronRight />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  )
}
